import { render, staticRenderFns } from "./DesvFreq.vue?vue&type=template&id=00149866"
import script from "./DesvFreq.vue?vue&type=script&lang=js"
export * from "./DesvFreq.vue?vue&type=script&lang=js"
import style0 from "./DesvFreq.vue?vue&type=style&index=0&id=00149866&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports